import './App.css';
import { useState } from 'react'
import React from 'react';



function Task({ item, setItem }) {
  
  
  const handleDelete = (name) => {
    const filter = item.filter((todo)=>(
      todo.name !== name
    ))
    setItem(filter)
    
  }
  
  return (
      <ul>
        {
          item.map((todo, index) => (
               <li key={todo.id}>
                  <div className="App jello-horizontal">
                  <div className="info">
                   <p>{todo.name}</p>
                   <p>{todo.time}</p>
                   </div>
                   <button className="butt" onClick={()=>{
                     handleDelete(todo.name)
                   }}>Delete</button>
                  </div>
               </li>
            ))
        }
      </ul>
  );
}

export default Task;

